import { render, staticRenderFns } from "./loadingPage.vue?vue&type=template&id=45ab7aa5&scoped=true&lang=pug&"
import script from "./loadingPage.vue?vue&type=script&lang=js&"
export * from "./loadingPage.vue?vue&type=script&lang=js&"
import style0 from "./loadingPage.vue?vue&type=style&index=0&id=45ab7aa5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab7aa5",
  null
  
)

export default component.exports